import { cn } from "@src/shared/lib/utils";
import { getAssetUrl } from "@src/shared/utils/assets/getAssetUrl";

interface LogoProps
  extends React.DetailedHTMLProps<
    React.ImgHTMLAttributes<HTMLImageElement>,
    HTMLImageElement
  > {
  /**
   * `mark` and `lockup` are wordmarks; `icon` is the square app symbol (the
   * "S" on a blue disc) shared with the favicon and the extension's icons.
   */
  variant?: "mark" | "lockup" | "icon";
}

const SOURCES: Record<NonNullable<LogoProps["variant"]>, string> = {
  mark: "/images/slate-logo-mark.png",
  lockup: "/images/slate-logo.png",
  icon: "/images/favicon.svg",
};

const ALT_TEXT: Record<NonNullable<LogoProps["variant"]>, string> = {
  mark: "Slate",
  lockup: "Slate by Elation Health",
  icon: "Slate",
};

export const Logo = ({
  className,
  variant = "mark",
  alt,
  ...restProps
}: LogoProps) => {
  return (
    <img
      {...restProps}
      src={getAssetUrl(SOURCES[variant])}
      alt={alt ?? ALT_TEXT[variant]}
      className={cn("h-8 w-auto object-contain", className)}
    />
  );
};
